export default __webpack_public_path__ + "static/media/PharmacyLogo.e8c054e2.svg";